import React from 'react';
import type { ExternalRunProgressSnapshot } from '@chatsdet/types';
import { useExternalRunStream } from './useExternalRunStream';
import { mergeExternalRunProgress } from './externalRunProgressModel';

/** Combine the existing SSE stream with the run-detail response's durable state. */
export function useExternalRunProgress(
  runId: string | null,
  progress: ExternalRunProgressSnapshot | null,
  onResults: () => void
) {
  const stream = useExternalRunStream(runId, onResults);
  return React.useMemo(
    () => ({
      ...mergeExternalRunProgress(stream, progress),
      progress,
    }),
    [progress, stream]
  );
}
